export default __webpack_public_path__ + "static/media/faqs.b02b926d.svg";